//import { Menu } from "antd";
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './Menu.scss';

const MenuBar = () => {
  const location = useLocation();
  const [showHomeLink, setShowHomeLink] = useState(false);
  const cookies = new Cookies();
  //paths is a static variable
  // array format - 2 d array
  // inner array contains 1 element means url, name is same else 0 -> url, 1 -> name
  // let paths = [["", "Dashboard"], ["Compressor"], ["Listing"]];
  // console.log(location.pathname, "1");
  useEffect(() => {
    // console.log(location.pathname, "2");
    if (location.pathname !== '/') {
      setShowHomeLink(true);
    } else {
      setShowHomeLink(false);
    }
  }, [location.pathname]);
  if (location.pathname === '/login') return <></>;
  return (
    <div>
      {['lg'].map((expand) => (
      <Navbar key={expand} expand={expand} className="mb-3">
          <Container>
          <Navbar.Brand href="#home">
            <Link to="/">
              <img className="img-logo" src={'https://www.remitx.com/remitx-images/remitx.svg'} height="" width="" alt="" title="" />
            </Link>
          </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <Link to="/">
                  <img className="img-logo" src={'https://www.remitx.com/remitx-images/remitx.svg'} height="" width="120" alt="" title="" />
                </Link>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
              <Nav>
                {showHomeLink && <Nav.Link href="/">Home</Nav.Link>}
                <Nav.Link href="mailto:wecare@remitx.com">Help</Nav.Link>
                <Nav.Link href="/login" onClick={() => cookies.remove('access_token')}>
                  Logout
                </Nav.Link>
              </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
        ))}

      {/* <Menu mode="horizontal">
        
            {paths.map((item, key) => (
                <Menu.Item key={"nav"+key}>
                    <NavLink to={item[0].toLowerCase()}>
                        {item[1] || item[0]}
                    </NavLink>
                </Menu.Item>
            ))}
        </Menu> */}
    </div>
  );
};

export default MenuBar;
